// TODO: check all states are needed
export var RTCConnectionEvents;
(function (RTCConnectionEvents) {
    RTCConnectionEvents["CONNECTION_STATE"] = "CONNECTION_STATE";
    RTCConnectionEvents["DC_MESSAGE"] = "DC_MESSAGE";
    RTCConnectionEvents["TRACK"] = "TRACK";
    RTCConnectionEvents["SIGNAL"] = "SIGNAL";
})(RTCConnectionEvents || (RTCConnectionEvents = {}));
